import React from 'react';
import { Calendar } from 'primereact/calendar';

import GlobalTooltip from 'components/GlobalTooltip';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';

export default function Filter(props) {
  const { filter, refreshList, filterOnChange } = props;
  return (
    <div className="d-inline-flex filter-wrap autowidth">
      <div>
        <span className="p-input-icon-left input-shadow"></span>
      </div>
      <div className="d-flex align-items-center autowidth">
        <div className="d-flex align-items-center p-2 automation-filter filter-wraper">
          <span className="text-bold black-600 me-2">Filters: </span>

          <CaseListDropDown
            value={filter?.case_lead || null}
            onChange={(selectedOption) => filterOnChange({ target: { name: 'case_lead', value: selectedOption } })}
            name="case_lead"
            isClearable
            placeholder="By Case/Lead"
            noOptionsMessage="No Cases/Leads Found"
            isClient={false}
            disabled={false}
            excludeFromLoading={true}
          />
          <Calendar
            id="icon"
            name="instance_stop_time"
            dateFormat="mm/dd/yy"
            className="input-shadow filter-calender searchable-dropdown ms-2"
            value={filter?.instance_stop_time}
            onChange={filterOnChange}
            inputClassName="w-110"
            showIcon
            placeholder="Date"
            required
            maxDate={new Date()}
          />

          <div className="pointer ms-0 p-2">
            <GlobalTooltip tooltip="Reset Filter" position="top" target=".fa-sync-alt" showDelay={500}>
              <i className="fas fa-sync-alt" onClick={() => refreshList()}></i>
            </GlobalTooltip>
          </div>
        </div>
      </div>
    </div>
  );
}
